import { render, staticRenderFns } from "./offers-item.vue?vue&type=template&id=1b1c7746"
import script from "./offers-item.vue?vue&type=script&lang=js"
export * from "./offers-item.vue?vue&type=script&lang=js"
import style0 from "./offers-item.vue?vue&type=style&index=0&id=1b1c7746&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports